import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { Popover } from 'tea-component';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';

interface IGuideUrls {
  // userGuide?: string;
  documentation?: string;
  quickStart?: string;
}

interface IUserGuideProps {
  title?: React.ReactNode;
  showSplit?: boolean;
  options?: Array<{ key: keyof IGuideUrls; text: string; url: string; }>;
  className?: string;
  guideUrls?: IGuideUrls;
  onNavigate?: (key: keyof IGuideUrls, url: string) => void;
}

const defaultGuideUrls: Required<IGuideUrls> = {
  // userGuide: 'https://cube.dev/docs/product/data-modeling/reference/cube',
  documentation: 'https://cube.dev/docs/product/data-modeling/reference/cube',
  quickStart: 'https://doc.weixin.qq.com/doc/w3_ASUATAZGAHECNBa1vh01rRySC0Ce1?scode=AJEAIQdfAAos0zYO1nAGgALgaWAEw',
};

const UserGuide: React.FC<IUserGuideProps> = (props) => {
  const { title, showSplit = true, className, guideUrls, options: propsOptions, onNavigate, ...restProps } = props || {};
  const { formatMessage } = useIntl();
  const urls = useMemo(() => ({ ...defaultGuideUrls, ...(guideUrls || {}) }), [guideUrls]);

  const options = propsOptions || [
    // { key: 'userGuide', text: formatMessage({ id: 'dbl_model_management_official_user_guide' }), url: urls.userGuide },
    { key: 'quickStart', text: formatMessage({ id: 'dbl_model_management_quick_start' }), url: urls.quickStart },
    { key: 'documentation', text: formatMessage({ id: 'dbl_model_management_official_documentation' }), url: urls.documentation },
  ];

  const handleClick = (key: keyof IGuideUrls, url: string): void => {
    if (onNavigate) {
      onNavigate(key, url);
    }
    window.open(url);
  };

  const overlay = (
    <div className='dbl-user-guide-overlay-body'>
      {options.map((item) => (
        <div
          key={item.key as string}
          className="dbl-user-guide-overlay-body-item"
          onClick={() => handleClick(item.key, item.url)}
          role="button"
          tabIndex={0}
        >
          {item.text}
        </div>
      ))}
    </div>
  );

  return (
    <div className={classNames('dbl-user-guide-title', className)}>
      {title}
      {showSplit && <div className="dbl-user-guide-title-split" />}
      <Popover
        overlayClassName='dbl-user-guide-overlay'
        trigger="hover"
        placement="bottom-start"
        overlay={overlay}
        placementOffset={[22, 0]}
        {...(restProps || {})}
      >
        <div className={classNames('dbl-user-guide-title-guide')}>
          <SvgIcon className="dbl-user-guide-title-icon" type="aigc-share" />
          {formatMessage({ id: 'dbl_model_management_official_user_guide' })}
        </div>
      </Popover>
    </div>
  );
};

export default UserGuide;
